import { EditDelegateRightsComponent } from './edit-delegaterights/edit-delegaterights.component';
import { AddDelegateRightsComponent } from './add-delegaterights/add-delegaterights.component';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ListDelegateRightsComponent } from './list-delegaterights/list-delegaterights.component';

export const routesDelegateRights: Routes = [
    { path: 'delegaterights', component: ListDelegateRightsComponent },
    { path: 'delegaterights/add', component: AddDelegateRightsComponent },
    { path: 'delegaterights/:id/edit', component: EditDelegateRightsComponent },
];

export const DelegateRightsRoutes: ModuleWithProviders = RouterModule.forChild(routesDelegateRights);
